export default [
  '1tv',
  '1up.com',
  '20min',
  '220.ro',
  '23video',
  '24video',
  '3qsdn',
  '3sat',
  '4tube',
  '56.com',
  '5min',
  '6play',
  '7plus',
  '8tracks',
  '91porn',
  '9c9media',
  '9c9media:stack',
  '9gag',
  '9now.com.au',
  'abc.net.au',
  'abc.net.au:iview',
  'abcnews',
  'abcnews:video',
  'abcotvs',
  'abcotvs:clips',
  'AcademicEarth:Course',
  'acast',
  'acast:channel',
  'AddAnime',
  'ADN',
  'AdobeTV',
  'AdobeTVChannel',
  'AdobeTVShow',
  'AdobeTVVideo',
  'AdultSwim',
  'aenetworks',
  'afreecatv',
  'AirMozilla',
  'AliExpressLive',
  'AlJazeera',
  'Allocine',
  'AlphaPorno',
  'AMCNetworks',
  'AmericasTestKitchen',
  'anderetijden',
  'AnimeOnDemand',
  'anitube.se',
  'Anvato',
  'AnySex',
  'Aparat',
  'AppleConnect',
  'AppleDaily',
  'appletrailers',
  'appletrailers:section',
  'archive.org',
  'ARD',
  'ARD:mediathek',
  'Arkena',
  'arte.tv',
  'arte.tv:+7',
  'arte.tv:cinema',
  'arte.tv:concert',
  'arte.tv:creative',
  'arte.tv:ddc',
  'arte.tv:embed',
  'arte.tv:future',
  'arte.tv:info',
  'arte.tv:magazine',
  'arte.tv:playlist',
  'AsianCrush',
  'AsianCrushPlaylist',
  'AtresPlayer',
  'ATTTechChannel',
  'ATVAt',
  'AudiMedia',
  'AudioBoom',
  'audiomack',
  'audiomack:album',
  'auroravid',
  'AWAAN',
  'awaan:live',
  'awaan:season',
  'awaan:video',
  'AZMedien',
  'AZMedienPlaylist',
  'AZMedienShowPlaylist',
  'BaiduVideo',
  'bambuser',
  'bambuser:channel',
  'Bandcamp',
  'Bandcamp:album',
  'Bandcamp:weekly',
  'bangumi.bilibili.com',
  'bbc: BBC',
  'bbc.co.uk: BBC iPlayer',
  'bbc.co.uk:article: BBC articles',
  'bbc.co.uk:iplayer:playlist',
  'bbc.co.uk:playlist',
  'Beatport',
  'Beeg',
  'BehindKink',
  'BellMedia',
  'Bet',
  'Bigflix',
  'Bild: Bild.de',
  'BiliBili',
  'BioBioChileTV',
  'BIQLE',
  'BleacherReport',
  'BleacherReportCMS',
  'blinkx',
  'Bloomberg',
  'BokeCC',
  'BostonGlobe',
  'Bpb',
  'BR: Bayerischer Rundfunk',
  'BravoTV',
  'Break',
  'brightcove:legacy',
  'brightcove:new',
  'BRMediathek',
  'bt:article',
  'bt:vestlendingen',
  'BuzzFeed',
  'BYUtv',
  'Camdemy',
  'CamdemyFolder',
  'CamWithHer',
  'canalc2.tv',
  'Canalplus',
  'Canvas',
  'CanvasEen',
  'CarambaTV',
  'CarambaTVPage',
  'CartoonNetwork',
  'cbc.ca',
  'cbc.ca:olympics',
  'cbc.ca:player',
  'cbc.ca:watch',
  'cbc.ca:watch:video',
  'CBS',
  'CBSInteractive',
  'CBSLocal',
  'cbsnews',
  'cbsnews:livevideo',
  'CBSSports',
  'CCMA',
  'CCTV',
  'CDA',
  'CeskaTelevize',
  'CeskaTelevizePorady',
  'channel9',
  'CharlieRose',
  'Chaturbate',
  'Chilloutzone',
  'chirbit',
  'chirbit:profile',
  'Cinchcast',
  'CJSW',
  'cliphunter',
  'Clippit',
  'ClipRs',
  'Clipsyndicate',
  'CloserToTruth',
  'cloudtime',
  'Cloudy',
  'Clubic',
  'Clyp',
  'cmt.com',
  'CNBC',
  'CNN',
  'CNNArticle',
  'CNNBlogs',
  'ComCarCoff',
  'ComedyCentral',
  'ComedyCentralFullEpisodes',
  'ComedyCentralShortname',
  'ComedyCentralTV',
  'CondeNast',
  'Corus',
  'Coub',
  'Cracked',
  'Crackle',
  'Criterion',
  'CrooksAndLiars',
  'Crunchyroll',
  'crunchyroll:playlist',
  'CSNNE',
  'CSpan',
  'CtsNews',
  'CTVNews',
  'Culturebox',
  'CultureUnplugged',
  'curiositystream',
  'curiositystream:collection',
  'CWTV',
  'DailyMail',
  'dailymotion',
  'dailymotion:playlist',
  'dailymotion:user',
  'DaisukiMotto',
  'DaisukiMottoPlaylist',
  'daum.net',
  'daum.net:clip',
  'daum.net:playlist',
  'daum.net:user',
  'DBTV',
  'DctpTv',
  'DeezerPlaylist',
  'defense.gouv.fr',
  'democracynow',
  'DHM',
  'Digg',
  'DigitallySpeaking',
  'Digiteka',
  'Discovery',
  'DiscoveryGo',
  'DiscoveryGoPlaylist',
  'DiscoveryNetworksDe',
  'DiscoveryVR',
  'Disney',
  'Dotsub',
  'DouyuShow',
  'DouyuTV: 斗鱼',
  'DPlay',
  'DPlayIt',
  'dramafever',
  'dramafever:series',
  'DRBonanza',
  'Dropbox',
  'DrTuber',
  'drtv',
  'drtv:live',
  'Dumpert',
  'dvtv',
  'dw',
  'dw:article',
  'EaglePlatform',
  'EbaumsWorld',
  'EchoMsk',
  'egghead:course',
  'egghead:lesson',
  'eHow',
  'Einthusan',
  'eitb.tv',
  'EllenTube',
  'EllenTubePlaylist',
  'EllenTubeVideo',
  'ElPais: El País',
  'Embedly',
  'EMPFlix',
  'Engadget',
  'Eporner',
  'EroProfile',
  'Escapist',
  'ESPN',
  'ESPNArticle',
  'EsriVideo',
  'ETOnline',
  'Europa',
  'EveryonesMixtape',
  'ExpoTV',
  'ExtremeTube',
  'EyedoTV',
  'facebook',
  'FacebookPluginsVideo',
  'faz.net',
  'fc2',
  'fc2:embed',
  'Fczenit',
  'filmon',
  'filmon:channel',
  'Filmweb',
  'FiveThirtyEight',
  'FiveTV',
  'Flickr',
  'Flipagram',
  'Folketinget',
  'FootyRoom',
  'Formula1',
  'FOX',
  'FOX9',
  'Foxgay',
  'foxnews',
  'foxnews:article',
  'foxnews:insider',
  'FoxSports',
  'france2.fr:generation-what',
  'FranceCulture',
  'FranceInter',
  'FranceTV',
  'FranceTVEmbed',
  'francetvinfo.fr',
  'FranceTVJeunesse',
  'FranceTVSite',
  'Freesound',
  'freespeech.org',
  'FreshLive',
  'Funimation',
  'Funk',
  'FunnyOrDie',
  'Fusion',
  'Fux',
  'FXNetworks',
  'GameInformer',
  'GameOne',
  'gameone:playlist',
  'GameSpot',
  'GameStar',
  'Gaskrank',
  'Gazeta',
  'GDCVault',
  'generic',
  'Gfycat',
  'GiantBomb',
  'Giga',
  'Glide',
  'Globo',
  'GloboArticle',
  'Go',
  'Go90',
  'GodTube',
  'Golem',
  'GoogleDrive',
  'Goshgay',
  'GPUTechConf',
  'Groupon',
  'Hark',
  'hbo',
  'hbo:episode',
  'HearThisAt',
  'Heise',
  'HellPorno',
  'Helsinki',
  'HentaiStigma',
  'hetklokhuis',
  'hgtv.com:show',
  'HistoricFilms',
  'history:topic',
  'hitbox',
  'hitbox:live',
  'HitRecord',
  'HornBunny',
  'HotNewHipHop',
  'HotStar',
  'hotstar:playlist',
  'Howcast',
  'HowStuffWorks',
  'HRTi',
  'HRTiPlaylist',
  'Huajiao',
  'HuffPost',
  'Hypem',
  'Iconosquare',
  'ign.com',
  'imdb',
  'imdb:list',
  'Imgur',
  'ImgurAlbum',
  'Ina',
  'Inc',
  'Indavideo',
  'IndavideoEmbed',
  'InfoQ',
  'Instagram',
  'instagram:user',
  'Internazionale',
  'InternetVideoArchive',
  'IPrima',
  'iqiyi',
  'Ir90Tv',
  'ITTF',
  'ITV',
  'ivi',
  'ivi:compilation',
  'ivideon',
  'Iwara',
  'Izlesene',
  'Jamendo',
  'JamendoAlbum',
  'JeuxVideo',
  'Joj',
  'Jove',
  'jpopsuki.tv',
  'JWPlatform',
  'Kakao',
  'Kaltura',
  'KanalPlay',
  'Kankan',
  'Karaoketv',
  'KarriereVideos',
  'keek',
  'KeezMovies',
  'Ketnet',
  'KhanAcademy',
  'KickStarter',
  'KonserthusetPlay',
  'kontrtube',
  'KrasView',
  'Ku6',
  'KUSI',
  'kuwo:album',
  'kuwo:category',
  'kuwo:chart',
  'kuwo:mv',
  'kuwo:singer',
  'kuwo:song',
  'la7.it',
  'laola1tv',
  'laola1tv:embed',
  'LCI',
  'Lcp',
  'LcpPlay',
  'Le',
  'Learnr',
  'Lecture2Go',
  'LEGO',
  'Lemonde',
  'LePlaylist',
  'LetvCloud',
  'Libsyn',
  'life: Life.ru',
  'life:embed',
  'limelight',
  'limelight:channel',
  'limelight:channel_list',
  'LiTV',
  'LiveLeak',
  'LiveLeakEmbed',
  'livestream',
  'livestream:original',
  'LnkGo',
  'loc: Library of Congress',
  'LocalNews8',
  'LoveHomePorn',
  'lrt.lt',
  'lynda: lynda.com videos',
  'lynda:course: lynda.com online courses',
  'm6',
  'macgamestore',
  'mailru',
  'mailru:music',
  'mailru:music:search',
  'MakersChannel',
  'MakerTV',
  'mangomolo:live',
  'mangomolo:video',
  'ManyVids',
  'massengeschmack.tv',
  'MatchTV',
  'MDR: MDR.DE and KiKA',
  'media.ccc.de',
  'Medialaan',
  'Mediaset',
  'Mediasite',
  'Medici',
  'megaphone.fm',
  'Meipai',
  'MelonVOD',
  'META',
  'metacafe',
  'Metacritic',
  'Mgoon',
  'MGTV: 芒果TV',
  'MiaoPai',
  'Minhateca',
  'MinistryGrid',
  'Minoto',
  'miomio.tv',
  'MiTele: mitele.es',
  'mixcloud',
  'mixcloud:playlist',
  'mixcloud:stream',
  'mixcloud:user',
  'Mixer:live',
  'Mixer:vod',
  'MLB',
  'Mnet',
  'MoeVideo',
  'Mofosex',
  'Mojvideo',
  'Moniker',
  'Morningstar',
  'Motherless',
  'MotherlessGroup',
  'Motorsport',
  'MovieClips',
  'MovieFap',
  'Moviezine',
  'MovingImage',
  'MSN',
  'mtg',
  'mtv',
  'mtv.de',
  'mtv81',
  'mtv:video',
  'mtvservices:embedded',
  'MuenchenTV',
  'MusicPlayOn',
  'mva: Microsoft Virtual Academy videos',
  'mva:course',
  'Mwave',
  'MwaveMeetGreet',
  'MySpace',
  'MySpace:album',
  'MySpass',
  'Myvi',
  'MyVidster',
  'MyviEmbed',
  'n-tv.de',
  'natgeo',
  'natgeo:episodeguide',
  'natgeo:video',
  'Naver',
  'NBA',
  'NBC',
  'NBCNews',
  'nbcolympics',
  'nbcolympics:stream',
  'NBCSports',
  'NBCSportsVPlayer',
  'ndr: NDR.de',
  'ndr:embed',
  'ndr:embed:base',
  'NDTV',
  'NerdCubedFeed',
  'netease:album',
  'netease:djradio',
  'netease:mv',
  'netease:playlist',
  'netease:program',
  'netease:singer',
  'netease:song',
  'Netzkino',
  'Newgrounds',
  'NewgroundsPlaylist',
  'Newstube',
  'NextMedia',
  'NextMediaActionNews',
  'NextTV: 壹電視',
  'Nexx',
  'NexxEmbed',
  'nfb: National Film Board of Canada',
  'nfl.com',
  'NhkVod',
  'nhl.com',
  'nhl.com:news',
  'nhl.com:videocenter',
  'nhl.com:videocenter:category',
  'nick.com',
  'nick.de',
  'nickelodeon:br',
  'nickelodeonru',
  'nicknight',
  'niconico',
  'NiconicoPlaylist',
  'Nintendo',
  'njoy: N-JOY',
  'njoy:embed',
  'NJPWWorld',
  'NobelPrize',
  'Noco',
  'NonkTube',
  'Noovo',
  'Normalboots',
  'NosVideo',
  'Nova',
  'nowness',
  'nowness:playlist',
  'nowness:series',
  'nowvideo: NowVideo',
  'Noz',
  'npo',
  'npo.nl:live',
  'npo.nl:radio',
  'npo.nl:radio:fragment',
  'Npr',
  'NRK',
  'NRKPlaylist',
  'NRKSkole',
  'NRKTV',
  'NRKTVDirekte',
  'NRKTVEpisodes',
  'NRKTVSeries',
  'ntv.ru',
  'Nuvid',
  'NYTimes',
  'NYTimesArticle',
  'NZZ',
  'ocw.mit.edu',
  'OdaTV',
  'Odnoklassniki',
  'OktoberfestTV',
  'on.aol.com',
  'OnDemandKorea',
  'onet.pl',
  'onet.tv',
  'onet.tv:channel',
  'OnetMVP',
  'OnionStudios',
  'Ooyala',
  'OoyalaExternal',
  'Openload',
  'OraTV',
  'orf:fm4',
  'orf:fm4:story',
  'orf:iptv',
  'orf:oe1',
  'orf:tvthek',
  'PacktPub',
  'PacktPubCourse',
  'PandaTV',
  'pandora.tv',
  'parliamentlive.tv',
  'Patreon',
  'pbs',
  'pcmag',
  'PearVideo',
  'People',
  'PerformGroup',
  'periscope',
  'periscope:user',
  'PhilharmonieDeParis',
  'phoenix.de',
  'Photobucket',
  'Piksel',
  'Pinkbike',
  'Pladform',
  'play.fm',
  'PlaysTV',
  'Playtvak',
  'Playvid',
  'Playwire',
  'pluralsight',
  'pluralsight:course',
  'plus.google: Google Plus',
  'podomatic',
  'Pokemon',
  'PolskieRadio',
  'PolskieRadioCategory',
  'PopcornTV',
  'PornCom',
  'PornerBros',
  'PornFlip',
  'PornHd',
  'PornHub',
  'PornHubPlaylist',
  'PornHubUserVideos',
  'Pornotube',
  'PornoVoisines',
  'PornoXO',
  'PornTube',
  'PressTV',
  'PrimeShareTV',
  'PromptFile',
  'prosiebensat1',
  'Puls4',
  'Pyvideo',
  'qqmusic',
  'qqmusic:album',
  'qqmusic:playlist',
  'qqmusic:singer',
  'qqmusic:toplist',
  'R7',
  'R7Article',
  'radio.de',
  'radiobremen',
  'radiocanada',
  'RadioCanadaAudioVideo',
  'radiofrance',
  'RadioJavan',
  'Rai',
  'RaiPlay',
  'RaiPlayLive',
  'RaiPlayPlaylist',
  'RBMARadio',
  'RDS: RDS.ca',
  'RedBullTV',
  'Reddit',
  'RedditR',
  'RedTube',
  'RegioTV',
  'RENTV',
  'RENTVArticle',
  'Restudy',
  'Reuters',
  'ReverbNation',
  'revision',
  'revision3:embed',
  'RICE',
  'RMCDecouverte',
  'RockstarGames',
  'RoosterTeeth',
  'RottenTomatoes',
  'Roxwel',
  'Rozhlas',
  'RTBF',
  'rte',
  'rte:radio',
  'rtl.nl',
  'rtl2',
  'rtl2:you',
  'rtl2:you:series',
  'RTP',
  'RTS',
  'rtve.es:alacarta',
  'rtve.es:infantil',
  'rtve.es:live',
  'rtve.es:television',
  'RTVNH',
  'RTVS',
  'Rudo',
  'RUHD',
  'RulePorn',
  'rutube',
  'rutube:channel',
  'rutube:embed',
  'rutube:movie',
  'rutube:person',
  'rutube:playlist',
  'RUTV',
  'Ruutu',
  'Ruv',
  'safari',
  'safari:api',
  'safari:course',
  'Sapo',
  'savefrom.net',
  'SBS',
  'schooltv',
  'screen.yahoo:search',
  'Screencast',
  'ScreencastOMatic',
  'scrippsnetworks:watch',
  'Seeker',
  'SenateISVP',
  'SendtoNews',
  'ServingSys',
  'Servus',
  'Sexu',
  'SeznamZpravy',
  'SeznamZpravyArticle',
  'Shahid',
  'ShahidShow',
  'Shared: shared.sx',
  'ShowRoomLive',
  'Sina',
  'SkylineWebcams',
  'skynewsarabia:article',
  'skynewsarabia:video',
  'SkySports',
  'Slideshare',
  'SlidesLive',
  'Slutload',
  'smotri',
  'smotri:broadcast',
  'smotri:community',
  'smotri:user',
  'Snotr',
  'Sohu',
  'SonyLIV',
  'soundcloud',
  'soundcloud:playlist',
  'soundcloud:search',
  'soundcloud:set',
  'soundcloud:trackstation',
  'soundcloud:user',
  'soundgasm',
  'soundgasm:profile',
  'southpark.cc.com',
  'southpark.cc.com:español',
  'southpark.de',
  'southpark.nl',
  'southparkstudios.dk',
  'SpankBang',
  'Spankwire',
  'Spiegel',
  'Spiegel:Article',
  'Spiegeltv',
  'Spike',
  'Sport5',
  'SportBoxEmbed',
  'SportDeutschland',
  'SpringboardPlatform',
  'Sprout',
  'sr:mediathek',
  'SRGSSR',
  'SRGSSRPlay',
  'stanfordoc',
  'Steam',
  'Stitcher',
  'Streamable',
  'Streamango',
  'streamcloud.eu',
  'StreamCZ',
  'StreetVoice',
  'StretchInternet',
  'SunPorno',
  'SVT',
  'SVTPlay',
  'SWRMediathek',
  'Syfy',
  'SztvHu',
  't-online.de',
  'Tagesschau',
  'tagesschau:player',
  'Tass',
  'TastyTrade',
  'TBS',
  'TDSLifeway',
  'teachertube',
  'teachertube:user:collection',
  'TeachingChannel',
  'Teamcoco',
  'TechTalks',
  'techtv.mit.edu',
  'ted',
  'Tele13',
  'TeleBruxelles',
  'Telecinco',
  'Telegraaf',
  'TeleMB',
  'TeleQuebec',
  'TeleQuebecEmission',
  'TeleQuebecLive',
  'TeleTask',
  'Telewebion',
  'TF1',
  'TFO',
  'TheIntercept',
  'theoperaplatform',
  'ThePlatform',
  'ThePlatformFeed',
  'TheScene',
  'TheStar',
  'TheSun',
  'TheWeatherChannel',
  'ThisAmericanLife',
  'ThisAV',
  'ThisOldHouse',
  'tinypic: tinypic.com videos',
  'TMZ',
  'TMZArticle',
  'TNAFlix',
  'TNAFlixNetworkEmbed',
  'toggle',
  'ToonGoggles',
  'Tosh: Tosh.0',
  'tou.tv',
  'Toypics',
  'ToypicsUser',
  'TrailerAddict',
  'Trilulilu',
  'TruTV',
  'Tube8',
  'TubiTv',
  'Tumblr',
  'tunein:clip',
  'tunein:program',
  'tunein:station',
  'tunein:topic',
  'TunePk',
  'Turbo',
  'Tutv',
  'tv.dfb.de',
  'TV2',
  'tv2.hu',
  'TV2Article',
  'TV3',
  'TV4',
  'TV5MondePlus',
  'TVA',
  'TVANouvelles',
  'TVANouvellesArticle',
  'TVC',
  'TVCArticle',
  'tvigle',
  'tvland.com',
  'TVN24',
  'TVNoe',
  'TVNow',
  'TVNowList',
  'tvp',
  'tvp:embed',
  'tvp:series',
  'TVPlayer',
  'Tweakers',
  'twitch:chapter',
  'twitch:clips',
  'twitch:profile',
  'twitch:stream',
  'twitch:video',
  'twitch:videos:all',
  'twitch:videos:highlights',
  'twitch:videos:past-broadcasts',
  'twitch:videos:uploads',
  'twitch:vod',
  'twitter',
  'twitter:amplify',
  'twitter:card',
  'udemy',
  'udemy:course',
  'UDNEmbed',
  'UFCTV',
  'UKTVPlay',
  'umg:de',
  'Unistra',
  'Unity',
  'uol.com.br',
  'uplynk',
  'uplynk:preplay',
  'Upskill',
  'UpskillCourse',
  'Urort',
  'URPlay',
  'USANetwork',
  'USAToday',
  'ustream',
  'ustream:channel',
  'ustudio',
  'ustudio:embed',
  'Varzesh3',
  'Vbox7',
  'VeeHD',
  'Veoh',
  'Vessel',
  'Vesti: Вести.Ru',
  'Vevo',
  'VevoPlaylist',
  'VGTV',
  'vh1.com',
  'Viafree',
  'vice',
  'vice:article',
  'vice:show',
  'Viceland',
  'Vidbit',
  'Viddler',
  'Videa',
  'video.google:search',
  'video.mit.edu',
  'VideoDetective',
  'videofy.me',
  'VideoMega',
  'videomore',
  'videomore:season',
  'videomore:video',
  'VideoPremium',
  'VideoPress',
  'videoweed',
  'Vidio',
  'VidLii',
  'vidme',
  'vidme:user',
  'vidme:user:likes',
  'Vidzi',
  'vier',
  'vier:videos',
  'ViewLift',
  'ViewLiftEmbed',
  'Viewster',
  'Viidea',
  'viki',
  'viki:channel',
  'vimeo',
  'vimeo:album',
  'vimeo:channel',
  'vimeo:group',
  'vimeo:likes',
  'vimeo:ondemand',
  'vimeo:review',
  'vimeo:user',
  'vimeo:watchlater',
  'Vimple',
  'Vine',
  'vine:user',
  'Viu',
  'viu:ott',
  'viu:playlist',
  'Vivo: vivo.sx',
  'vk',
  'vk:uservideos',
  'vk:wallpost',
  'vlive',
  'vlive:channel',
  'vlive:playlist',
  'Vodlocker',
  'VODPl',
  'VODPlatform',
  'VoiceRepublic',
  'Voot',
  'VoxMedia',
  'VoxMediaVolume',
  'Vporn',
  'vpro',
  'Vrak',
  'VRT',
  'VrtNU',
  'vrv',
  'vrv:series',
  'VShare',
  'vube',
  'VuClip',
  'VVVVID',
  'VyboryMos',
  'Vzaar',
  'Walla',
  'washingtonpost',
  'washingtonpost:article',
  'wat.tv',
  'WatchBox',
  'WatchIndianPorn',
  'WDR',
  'wdr:mobile',
  'WDRElefant',
  'WDRPage',
  'Webcaster',
  'WebcasterFeed',
  'WebOfStories',
  'WebOfStoriesPlaylist',
  'Weibo',
  'WeiboMobile',
  'WeiqiTV',
  'wholecloud',
  'Wimp',
  'Wistia',
  'wnl',
  'WorldStarHipHop',
  'wrzuta.pl',
  'wrzuta.pl:playlist',
  'WSJ',
  'WSJArticle',
  'XBef',
  'XboxClips',
  'XFileShare',
  'XHamster',
  'XHamsterEmbed',
  'xiami:album',
  'xiami:artist',
  'xiami:collection',
  'xiami:song',
  'ximalaya',
  'ximalaya:album',
  'XMinus',
  'XNXX',
  'Xstream',
  'XTube',
  'XTubeUser',
  'Xuite',
  'XVideos',
  'XXXYMovies',
  'Yahoo',
  'YandexDisk',
  'yandexmusic:album',
  'yandexmusic:playlist',
  'yandexmusic:track',
  'YapFiles',
  'YesJapan',
  'yinyuetai:video',
  'Ynet',
  'YouJizz',
  'youku',
  'youku:show',
  'YouNowChannel',
  'YouNowLive',
  'YouNowMoment',
  'YouPorn',
  'YourUpload',
  'youtube',
  'youtube:channel',
  'youtube:favorites',
  'youtube:history',
  'youtube:live',
  'youtube:playlist',
  'youtube:playlists',
  'youtube:recommended',
  'youtube:search',
  'youtube:search:date',
  'youtube:search_url',
  'youtube:show',
  'youtube:subscriptions',
  'youtube:user',
  'youtube:watchlater',
  'Zapiks',
  'Zaq1',
  'ZDF',
  'ZDFChannel',
  'zingmp3',
];
